export const ScriptLabels = {
    ONE_ABOVE_LOWEST: "LOWEST_PLUS_1",
    BOTH_UPPER_LOWER: "BOTH_UPPER_LOWER",
    BELOW_STAFF: "BELOW_STAFF",
    ALL_KEYS: "ALL_KEYS",
}
